import type { Location, LocationError } from '../types/location';
import io from './ioService';
import { getUserId } from './localStorageService';

class GeoLocationService {
  sendLocation = (location: Location, configId: string) => {
    const id = getUserId(configId);
    const payload = {
      available: true,
      coordinates: {
        latitude: location.latitude,
        longitude: location.longitude,
      },
    };
    io.send({
      event: 'location',
      data: { id, type: 'location', data: payload },
    });
  };

  sendLocationError = (error: LocationError, configId: string) => {
    const id = getUserId(configId);
    io.send({
      event: 'location',
      data: {
        id,
        type: 'location',
        data: {
          available: false,
          error: `#${error.code} - with message: ${error.message}`,
        },
      },
    });
  };
}

export default new GeoLocationService();
